/*
 * @Author: 张志明
 * @Date: 2020-11-03 17:32:58
 * @LastEditTime: 2024-03-07 16:37:20
 * @Description:
 */
const install = function (Vue) {
    Vue.directive('onlyNum', {
        bind(el, binding, vnode) {
            const ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
            ele.oninput = function () {
                let val = ele.value;
                const arg = parseInt(binding.arg);
                const { max = 999999999 } = binding.value || {};
                if (arg) {
                    val = val.replace(/[^\d.]/g, ''); // 清除"数字"和"."以外的字符
                    val = val.replace(/^\./g, ''); // 验证第一个字符是数字
                    val = val.replace(/\.{2,}/g, '.'); // 只保留第一个, 清除多余的
                    val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
                    const reg = new RegExp(`^(\\-)*(\\d+)\\.(\\d{${arg}}).*$`);
                    val = val.replace(reg, '$1$2.$3'); // 只能输入三个小数
                } else {
                    val = val.replace(/[^\d]/g, '');
                }
                if (val !== '') {
                    if (parseFloat(val) > max) {
                        val = max;
                    }
                    // else if (parseFloat(val) < min) {
                    //   val = min;
                    // }
                }
                ele.value = val;
                vnode.componentInstance.$emit('input', val);
            };
            ele.onblur = function () {
                let val = ele.value;
                const { min, canEmpty = false } = binding.value || {};

                if (val !== '' && min) {
                    if (parseFloat(val) < min) {
                        val = min;
                    }
                } else if (min && !canEmpty) {
                    val = min;
                }
                ele.value = val;
                vnode.componentInstance.$emit('input', val);
                vnode.componentInstance.$emit('change', val);
            };
        },
        unbind(el) {
            const ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
            ele.oninput = ele.onblur = null;
        },
    });
};

export default {
    install,
};
